import React, { Component, PropTypes } from 'react'

import { sendPatchRequest } from '../utils'

import { Boolean, MultipleYesNo, TextInput } from '../ui'

export default class InsuranceForm extends Component {
    static propTypes = {
        data: PropTypes.object,
        errors: PropTypes.object.isRequired,
        options: PropTypes.object.isRequired,
        updateValue: PropTypes.func.isRequired,
        updateValueAndSendPatchRequest: PropTypes.func.isRequired,
    }

    updateWrkCmp = (data) => {
        this.props.updateValueAndSendPatchRequest({
            wrk_cmp: data.wrk_cmp ? 1 : 2,
        })
    }

    render() {
        const errors = this.props.errors

        if (! this.props.data) {
            return null
        }

        let workmansCompFields = null

        if (this.props.data.wrk_cmp === 1) {
            workmansCompFields = (
                <div className="grid grid--break-mobile">
                    <div className="grid__span-6">
                        <TextInput
                            error={ errors.wrk_cmp_policy_number }
                            handleBlur={ sendPatchRequest.bind(this, 'wrk_cmp_policy_number') }
                            label="Insurance Policy Number"
                            name="wrk_cmp_policy_number"
                            updateValue={ this.props.updateValue }
                            value={ this.props.data.wrk_cmp_policy_number }
                        />
                    </div>
                    <div className="grid__span-6">
                        <TextInput
                            error={ errors.wrk_cmp_carrier_name }
                            handleBlur={ sendPatchRequest.bind(this, 'wrk_cmp_carrier_name') }
                            label="Insurance Carrier Name"
                            name="wrk_cmp_carrier_name"
                            updateValue={ this.props.updateValue }
                            value={ this.props.data.wrk_cmp_carrier_name }
                        />
                    </div>
                </div>
            )
        }

        return (
            <div className="form">
                <div className="grid grid--break-mobile">
                    <div className="grid__span-6">
                        <MultipleYesNo
                            error={ errors.insurance_map }
                            name="insurance_map"
                            options={ this.props.options.insuranceTypeOptions }
                            updateValue={ this.props.updateValueAndSendPatchRequest }
                            value={ this.props.data.insurance_map }
                        />
                    </div>
                    <div className="grid__span-6">
                        <Boolean
                            error={ errors.wrk_cmp }
                            label="Do you have workers compensation insurance?"
                            name="wrk_cmp"
                            updateValue={ this.updateWrkCmp }
                            value={
                                (this.props.data.wrk_cmp === 1) ? true : (
                                    (this.props.data.wrk_cmp === 2) ? false : null
                                )
                            }
                        />

                        { workmansCompFields }
                    </div>
                </div>
            </div>
        )
    }

}



// WEBPACK FOOTER //
// ./app/components/personal/insurance_form.js